import VacancyApi from '@/api/vacancy.js';
import vacancies from '@/store/modules/search/search_vacancies.js';
import invites from '@/store/modules/search/search_invites.js';
import responses from '@/store/modules/search/search_responses.js';

// this stuff is not taken from rootGetters['situation/api/responseAPI']
// import ResponseApi from '@/api/response.js'
// this stuff is not taken froAm rootGetters['situation/api/invitesPI']
// import InvitesApi from '@/api/invite.js'

import { setResponseComputedName } from '@/_helpers/utils.js';

const DEFAULT_COUNT = 5;

const DEFAULT_SORT_PARAMS = {
  sort_by: 'name',
  sort_order: 'asc'
};

const initialHint = () => {
  return {
    index: 0,
    vacancy: null,
    response: null,
    invite: null
  };
};

const state = {
  term: '',
  error: null,
  loading: false,
  vacancies: [],
  responses: [],
  invites: [],
  // This object for search results page
  resultSearch: {
    vacancies: [],
    responses: [],
    invites: [],
    term: null
  },
  xlsExportingResponses: false,
  xlsExportingInvites: false,
  currentActiveHint: initialHint(),
  waitResultsForTerm: null,
  lastSearchTermFetched: null
};

const actions = {
  fetch({ commit, dispatch, rootGetters }, { searchTerm }) {
    commit('SET_LOADING', true);

    let filter = [];
    filter.title = searchTerm;
    const defaultParams = {
      filter,
      limit: DEFAULT_COUNT,
      page: 1,
      ...DEFAULT_SORT_PARAMS
    };

    Promise.all([
      VacancyApi.fetchList(defaultParams),
      rootGetters['situation/api/responseAPI'].fetch(defaultParams),
      rootGetters['situation/api/invitesAPI'].fetch(defaultParams)
    ])
      .then(data => {
        commit('fetchVacanciesSuccess', data[0]);
        commit('fetchResponsesSuccess', data[1]);
        commit('fetchInvitesSuccess', data[2]);

        // We are waiting for search results on the result page
        // So we check searchTerm is exact what we are waiting for or not
        if (searchTerm === state.waitResultsForTerm) {
          // If so, copy results to show them on the page
          commit('prepareResultPage', {
            searchTerm,
            watch: false
          });
          commit('stopWaitResults');
        }

        commit('fetchSearchSuccess', searchTerm);
      })
      .catch(err => {
        commit('fetchSearchFailure', err);

        // We are waiting res on the result page
        if (searchTerm === state.waitResultsForTerm) {
          commit('stopWaitResults');
          dispatch('global/setError', err, { root: true });
        }
      });
  },

  xlsExportResponses({ commit, dispatch, rootGetters }, responsesIds) {
    commit('xlsExportingResponses', true);

    rootGetters['situation/api/responseAPI']
      .xlsExport({ ids: responsesIds })
      .then(data => {
        commit('xlsExportingResponses', false);
        window.location = data.data[0].url;
      })
      .catch(err => {
        commit('xlsExportingResponses', false);
        dispatch('global/setError', err, { root: true });
      });
  },

  xlsExportInvites({ commit, dispatch, rootGetters }, searchQuery) {
    commit('xlsExportingInvites', true);

    rootGetters['situation/api/invitesAPI']
      .getExcelImportLink({
        search_term: searchQuery,
        ...DEFAULT_SORT_PARAMS
      })
      .then(data => {
        commit('xlsExportingInvites', false);
        window.location = data.url;
      })
      .catch(err => {
        commit('xlsExportingInvites', false);
        dispatch('global/setError', err, { root: true });
      });
  }
};

const mutations = {
  setTerm(state, term) {
    state.term = term;
  },

  SET_LOADING: (state, payload) => {
    state.loading = payload;
  },

  fetchSearchSuccess(state, searchTerm) {
    state.loading = false;
    state.lastSearchTermFetched = searchTerm;
  },

  fetchVacanciesSuccess(state, { data }) {
    state.vacancies = data;
  },

  fetchResponsesSuccess(state, { data }) {
    state.responses = data.map(response => setResponseComputedName(response));
  },

  fetchInvitesSuccess(state, { data }) {
    state.invites = data;
  },

  clearSearch(state) {
    state.vacancies = [];
    state.responses = [];
    state.invites = [];
  },

  xlsExportingResponses(state, flag) {
    state.xlsExportingResponses = flag;
  },

  xlsExportingInvites(state, flag) {
    state.xlsExportingInvites = flag;
  },

  // TODO: definitely need to rewrite this logic
  prepareResultPage(state, { searchTerm, watch }) {
    /* When redirect to search page we remember the search term
    for these cases, when fetch is not inited, but we already redirected */

    if (state.loading && watch && state.lastSearchTermFetched !== state.waitResultsForTerm) {
      state.waitResultsForTerm = searchTerm;
    } else {
      state.resultSearch = {
        vacancies: state.vacancies,
        responses: state.responses,
        invites: state.invites,
        term: state.term
      };
    }
  },

  stopWaitResults(state) {
    state.waitResultsForTerm = null;
  }
};

const getters = {
  vacancies: state => state.vacancies || [],
  responses: state => state.responses || [],
  invites: state => state.invites || [],

  query: state => state.term || '',

  responsesForResultPage: state => state.resultSearch.responses || [],
  vacanciesForResultPage: state => state.resultSearch.vacancies || [],
  invitesForResultPage: state => state.resultSearch.invites || [],

  searchQueryForResultPage: state => state.resultSearch.term || ''
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    vacancies,
    invites,
    responses
  }
};
